import React, { PureComponent } from 'react';
import { withStyles } from 'tss-react/mui';
import { ThemeProvider } from '@mui/material/styles';
import { compose } from 'redux';
import Grid from '@mui/material/Grid';
import Hidden from '@mui/material/Hidden';
import { connect } from 'react-redux';

import api from '../api';
import Login from '../components/Login';
import { login as theme } from '../theme';
import notifSystem from '../notifSystem';
import logo from '../../public/home.jpg';
import lesbonsartisansdef from '../../public/lesbonsartisansdef.png';
import withRouter from '../components/Hoc/withRouter';
import { login as loginAction } from '../actions/auth';
import CustomImg from '../components/Utils/CustomImg';
import LoginResetPassword from '../components/LoginResetPassword';

const styles = {
  main: {
    backgroundColor: 'white',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    alignItems: 'center',
    zIndex: 300,
    transition: 'opacity 0.5s',
  },
  center: {
    margin: 'auto',
  },
  img: {
    width: '50%',
    height: '100%',
    'background-image': `url(${logo})`,
    'background-size': 'cover',
    'background-repeat': 'non-repeat',
    'background-position': 'right',
  },
  logo: {
    position: 'fixed',
    maxWidth: 300,
    top: 25,
    left: 50,
  }
};

export class LoginView extends PureComponent {
  state = {
    error: '',
    forgotPassword: false,
    resetPassword: false,
    resetPasswordDisabled: false,
  };

  login = async (login, password) => {
    try {
      const res = await api.login.post({
        login,
        pass: password,
      });
      if (res.statusCode() === 200) {
        const { token } = res.body().data();
        this.props.dispatch(loginAction(token));
        this.props.navigate('/');
        return true;
      }
    } catch (error) {
      notifSystem.error('Erreur', 'Connexion echouée');
      this.setState({
        error,
      });
    }
    return false;
  };

  forgetPasswordMode = (event) => {
    event.preventDefault();
    this.setState(
      {
        ...this.state,
        forgotPassword: !this.state?.forgotPassword
      }
    );
  };

  resetPasswordTimer = () => {
    this.setState({ ...this.state, resetPasswordDisabled: true });
    setTimeout(() =>
      this.setState({ ...this.state, resetPasswordDisabled: false }), 60000);
  };

  render() {
    const { classes } = this.props;
    const style = { opacity: 1 };
    return (
      <ThemeProvider theme={theme}>
        <Grid container className={classes.main} style={style}>
          <CustomImg
            src={lesbonsartisansdef}
            alt="logo"
            className={classes.logo}
            width={'100%'}
          />
          <Grid className={classes.center} item xs={12} md={12} lg={5}>
            {this.state.forgotPassword ? (
              <LoginResetPassword
                forgetPasswordMode={this.forgetPasswordMode}
                resetPasswordTimer={this.resetPasswordTimer}
                resetPasswordDisabled={this.state.resetPasswordDisabled}
                classes={classes}
              />
            ) : (
              <Login
                login={this.login}
                error={this.state.error}
                forgetPasswordMode={this.forgetPasswordMode}
              />
            )}
          </Grid>
          <Hidden mdDown>
            <div src={logo} alt="logo" className={classes.img} />
          </Hidden>
        </Grid>
      </ThemeProvider>
    );
  }
}

export default compose(
  withRouter, connect()
)(withStyles(LoginView, styles));
